package com.neurobs.ccabserver.translation.components.phrasetranslation.components

import com.neurobs.react.semanticui.{UiButtonFactory, UiGridFactory, UiHeaderFactory, UiLoaderFactory, UiMessageFactory}
import com.neurobs.react.{ReactUtil, StyleUtil}
import com.neurobs.ccabserver.translation.states.PhraseTranslationStateGenerator
import com.neurobs.react.ReactElementFactory
import org.scalajs.dom
import slinky.core.{FunctionalComponent, TagElement}
import slinky.core.annotations.react
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.core.facade.React.createRef
import slinky.core.facade.ReactElement
import slinky.web.html._

import scala.scalajs.js

@react
object UserTranslation {

  case class Props(enclosingElement: (ReactElement*) => ReactElement)

  val component = FunctionalComponent[Props] { props =>

    val phraseTranslationState = PhraseTranslationStateGenerator.accessState

    def awaitingServerUserTranslation = phraseTranslationState.awaitingServerUserTranslation

    props.enclosingElement(
      if (awaitingServerUserTranslation) Seq(UiLoaderFactory.ActiveTextLoader("Loading user translation..."))
      else phraseTranslationState.userTranslation match {
        case Left(errorOpt) => Seq(UiMessageFactory.BasicErrorMessage(errorOpt.getOrElse("Error loading user translation")))
        case Right(_) =>
          Seq(
            UiGridFactory.Grid(
              UserTranslationInput(
                enclosingElement = UiGridFactory.GridColumn(_)("thirteen wide center aligned")
              ),
              UserTranslationSaveButton(
                enclosingElement = UiGridFactory.GridColumn(_)("three wide center aligned")
              )
            )("middle aligned")
          )
      }
    )

  }
}

@react
object UserTranslationInput {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)

  val component = FunctionalComponent[Props] { props =>

    val phraseTranslationState = PhraseTranslationStateGenerator.accessState
    val translationInputRef = createRef[dom.html.TextArea]

    def handleBlur = () => {
      if (translationInputRef.current != null) {
        if (translationInputRef.current.value != phraseTranslationState.userTranslationText) {
          phraseTranslationState.updateUserTranslationText(translationInputRef.current.value)
        }

      }
    }
    def handleMouseOut = () => if (translationInputRef.current != null) translationInputRef.current.blur()


    useEffect(() => {
      if (translationInputRef.current != null) {
        translationInputRef.current.value = phraseTranslationState.userTranslationText
      }
    }, Vector(phraseTranslationState.userTranslationText))

    props.enclosingElement(
      Seq[ReactElement](
        UiHeaderFactory.TextHeader("User Translation", 2)(("", "white-text")),
        textarea(
          ref := translationInputRef,
          onBlur := handleBlur,
          onMouseOut := handleMouseOut,
          style := StyleUtil.makeStyle(("width", "100%"), ("height", "100px"), ("fontSize", "16px"), ("padding", "5px"))
        )
      )
    )
  }
}

@react
object UserTranslationSaveButton {

  case class Props(enclosingElement: (ReactElement*) => ReactElement)

  val component = FunctionalComponent[Props] { props =>

    val phraseTranslationState = PhraseTranslationStateGenerator.accessState

    useEffect(() => {

    }, Vector(phraseTranslationState.selectedPhrase))

    def isRepeatedPhrase = phraseTranslationState.selectedPhrase.map(_.phrase.isRepeated).getOrElse(false)

    def savingTranslation = phraseTranslationState.savingUserTranslation
    def saveTranslation = () => {
      if (!savingTranslation) phraseTranslationState.saveUserTranslation()
    }

    def buttonDisplay = if (savingTranslation) "" else "Save translation"
    def buttonModifiers = if (savingTranslation) "primary loading" else "primary"
    def buttonStyle = Seq[(String, js.Any)](("marginBottom", "10px"))


    props.enclosingElement(
      Seq[ReactElement](
        UiButtonFactory.Button(
          display = buttonDisplay,
          handleClick = saveTranslation
        )(buttonModifiers, buttonStyle),
        if (isRepeatedPhrase) ReactElementFactory.P("This phrase appears in multiple tests. Saving this translation will affect the phrase for all of the tests in which it appears.")
        else null
      )
    )


  }
}